interface StarIconProps extends React.HTMLProps<SVGElement> {
   color: string;
}

interface RatingStarsProps extends React.HTMLProps<HTMLDivElement> {
   rating_value: number;
   rating_max_value?: number;
   rating_color?: string;
}

const StarIcon: React.FC<StarIconProps> = ({ color }) => {
   const fill = color || 'transparent';
   return (
      <svg
         width="14"
         height="14"
         viewBox="0 0 14 14"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
         <path
            fill={fill}
            stroke="#646EC8"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.99994 10.0003L3.27702 11.4318C2.95112 11.6031 2.54804 11.4779 2.3767 11.152C2.30848 11.0222 2.28494 10.8735 2.30972 10.729L2.82975 7.69701L0.626863 5.54973C0.363207 5.29273 0.357812 4.87065 0.614813 4.607C0.717152 4.50201 0.851247 4.43368 0.996338 4.4126L4.04066 3.97023L5.40212 1.21162C5.56506 0.881446 5.96481 0.745887 6.29498 0.908835C6.42646 0.973722 6.53288 1.08014 6.59776 1.21162L7.95922 3.97023L11.0035 4.4126C11.3679 4.46555 11.6204 4.80384 11.5674 5.1682C11.5463 5.3133 11.478 5.44739 11.373 5.54973L9.17013 7.69701L9.69016 10.729C9.7524 11.0919 9.50867 11.4366 9.14578 11.4988C9.00128 11.5236 8.85263 11.5 8.72286 11.4318L5.99994 10.0003Z"
         />
      </svg>
   );
};

const RatingStars: React.FC<RatingStarsProps> = ({
   rating_value,
   rating_max_value = 5,
   rating_color = '#646EC8',
}) => {
   return (
      <div className="flex space-x-1">
         {rating_max_value && rating_max_value > 0
            ? [...Array(rating_max_value)].map((_key, index) => (
                 <StarIcon
                    key={index}
                    color={Math.floor(rating_value || 0) > index ? rating_color : 'transparent'}
                 />
              ))
            : ''}
      </div>
   );
};

export default RatingStars;
